<template>
    <div class="width-max">
        <div id="serial_footer_wrapper">
            <div id="serial_bzbslogo" style="text-align: center">
                <!-- <img src="@/assets/bzbslogo/buzzebees-logo-dark.svg"/> -->
                <img src="@/assets/linelogin/logo-new-theme.svg" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialFooter",
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
#serial_footer_wrapper {
    line-height: 23px;
    border-top: 2px solid #ded6c9;
    padding: {
        top: 20px;
        left: 25px;
        right: 25px;
        bottom: 5px;
    }

    #serial_bzbslogo {
        img {
            display: block;
            height: 20px;
            margin: {
                left: auto;
                right: auto;
            }
        }
    }
}
.width-max {
    width: -webkit-fill-available;
}
</style>
